<div style="height: 100%; display: flex; flex-direction: column; overflow: hidden">
  <div class="dialog__header" mat-dialog-title>
    <span class="dialog__title">Close Ticket</span>
  </div>
  <mat-dialog-content>
    @if (data.isLoadingConfirm) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
    <p class="dialog__message mb-0">Are you sure you want to close this ticket?</p>
    <form class="dialog__form mx-3" [formGroup]="formGroup">
      <p class="font-weight-regular">
        Please help us understand the resolution status <span class="text-error">*</span>:
      </p>
      <radio-group
        class="d-block mb-2 ml-3"
        [options]="resolutionStatuses"
        [reactiveForm]="formGroup"
        [controlName]="'resolutionStatus'"
      ></radio-group>
      <form-element-renderer
        class="d-block"
        [ngClass]="{ hidden: !showResolutionText, visible: showResolutionText }"
        [reactiveForm]="formGroup"
        [controlName]="'resolutionText'"
        [controlConfig]="resolutionTextControlConfig"
      ></form-element-renderer>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions class="dialog__actions">
    <button class="dialog__buttons-cancel" [mat-dialog-close]="true" [disabled]="data?.isLoadingConfirm">Cancel</button>
    <button
      mat-button
      color="primary"
      class="dialog__buttons-confirm ml-2"
      (click)="onConfirm()"
      [disabled]="data?.isLoadingConfirm || !formGroup.valid"
      [matTooltip]="!formGroup.valid ? confirmTooltip : ''"
    >
      @if (data.isLoadingConfirm) {
        <mat-spinner diameter="20" class="mat-spinner-color"></mat-spinner>
      } @else {
        Close Ticket
      }
    </button>
  </mat-dialog-actions>
</div>
